import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=35e117f0&scoped=true&"
import script from "./supplement.vue?vue&type=script&lang=js&"
export * from "./supplement.vue?vue&type=script&lang=js&"
import style0 from "./supplement.vue?vue&type=style&index=0&id=35e117f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e117f0",
  null
  
)

export default component.exports